import React from 'react'
import { ParallaxProvider } from 'react-scroll-parallax'
import { createGlobalStyle, ThemeProvider, css } from 'styled-components'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import styledNormalize from 'styled-normalize'
import { theme } from '../lib/styles'
import fontFiles from '../lib/fonts'
import '../lib/fragments' // has to be imported somewhere to gatsby notice that
import LinkedInInsight from '../components/LinkedInInsight'

const GlobalStyle = createGlobalStyle`${({ theme: { colors, fonts } }) => css`
  ${styledNormalize}
  ${fontsDef}

  body {
    /* background: white; */
    font-family: ${fonts.hind};
    color: ${colors.text};
    font-size: 0;
  }
  * {
    box-sizing: border-box;
  }
  p {
    margin: 0;
    padding: 0;
  }
  a {
    text-decoration: none;
    color: inherit;
  }
`}`

class App extends React.Component {
  componentDidCatch(e) {
    console.log('DID CATCH', e)
  }

  render() {
    const { children } = this.props
    return (
      <ParallaxProvider>
        <ThemeProvider theme={theme}>
          <>
            <GlobalStyle />
            {children}
          </>
          <LinkedInInsight partnerId="8405585" includeInDevelopment={false} />
        </ThemeProvider>
      </ParallaxProvider>
    )
  }
}

export default App

const fontsDef = css`
  @font-face {
    font-family: 'Hind';
    font-style: normal;
    font-display: swap;
    font-weight: 700;
    src: local('Hind'), url(${fontFiles.HindBold}) format('truetype');
  }
  @font-face {
    font-family: 'Hind';
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src: local('Hind'), url(${fontFiles.HindRegular}) format('truetype');
  }
  @font-face {
    font-family: 'Hind';
    font-style: normal;
    font-display: swap;
    font-weight: 300;
    src: local('Hind'), url(${fontFiles.HindLight}) format('truetype');
  }
`
